module.exports = __webpack_public_path__ + "img/content.91419931.png";